import { render, staticRenderFns } from "./food.vue?vue&type=template&id=1111ee84&scoped=true&"
import script from "./food.vue?vue&type=script&lang=js&"
export * from "./food.vue?vue&type=script&lang=js&"
import style0 from "./food.vue?vue&type=style&index=0&id=1111ee84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1111ee84",
  null
  
)

export default component.exports